/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

document.addEventListener('DOMContentLoaded', () => {
  const sectionFullWidth = document.querySelector('[data-section-id="template--17933597049071__section_multi_column_images_FkhD9"]');

  if (sectionFullWidth) {
    const containerFullWidth = sectionFullWidth.querySelector('.container.container--large');

    if (containerFullWidth) {
      containerFullWidth.classList.remove('container--large');
    }
  }
    (function() {

      var cupom1 = "primeira10";
    //   var cupom2 = "primeiraFreteGratis";

      if (!sessionStorage.getItem('primeira10')) {
        fetch('/discount/' + cupom1)
          .then(function() {
            console.log('cupom 1 aplicado');
            sessionStorage.setItem('primeira10', 'true');
          });
      }

    //   if (!sessionStorage.getItem('primeiraFreteGratis')) {
    //     fetch('/discount/' + cupom2)
    //       .then(function() {
    //         console.log('cupom 2 aplicado');
    //         sessionStorage.setItem('primeiraFreteGratis', 'true');
    //       });
    //   }
    })();
});

document.addEventListener('DOMContentLoaded', () => {

    //mobile

    const contactContainer = document.querySelector('.mobile-footer__contact');
    const oldSocialLinks = document.querySelector('.mobile-draw__footer .social-links');

    if (contactContainer) {
        const instagramItem = `
            <p class="mobile-footer__text">
              <a href="https://www.instagram.com/alfaiatarialinabe" target="_blank" class="mobile-footer__text-link">
                <span class="mobile-draw__icon">
                  <svg class="icon-svg icon-selection" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                  </svg>
                </span>&nbsp;@alfaiatarialinabe
              </a>
            </p>
        `;
        contactContainer.insertAdjacentHTML('beforeend', instagramItem);
    }

    if (oldSocialLinks) {
        oldSocialLinks.style.display = 'none';
    }

    //  footer 
    const socialWrapper = document.querySelector('.footer-nav__social-wrapper');

    if (socialWrapper) {
        const instagramItem = `
            <p class="footer-nav__text">
                <a aria-label="Instagram" href="https://www.instagram.com/alfaiatarialinabe" target="_blank" class="footer-nav__text-link">
                    @alfaiatarialinabe
                </a>
            </p>
        `;

        socialWrapper.insertAdjacentHTML('beforebegin', instagramItem);

        socialWrapper.style.display = 'none';
    }

    const mobileList = document.querySelector('.mobile-draw .drawer-nav--main .list-menu');

    if (mobileList) {
        const novoItem = `
            <li class="list-menu__item">
                <a href="https://www.linabe.com.br/collections/todos-os-produtos" class="list-menu__link list-menu__link--sub f-family--body f-caps--false f-space--0">
                    VER TODOS
                </a>
            </li>
        `;
        mobileList.insertAdjacentHTML('beforeend', novoItem);
    }
});

